import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { SlotPortal } from '@mint-lib/slots';
import { getRouteApi, Outlet, useLocation } from '@mint/routing';

import { useMediaPlanMetadataApi } from '../api/queries/useMediaPlanMetadataApi.js';
import { MP_LEVELS } from '../consts/index.js';
import {
  HIDE_PLANNING_SIDEBAR,
  SHOW_PLANNING_SIDEBAR,
} from '../consts/sidebar.js';
import { chooseLevel } from '../utils/chooseLevel.js';
import ConditionalApprovalProcessProvider from './components/ConditionalApprovalProcessProvider.jsx';
import PlanningSocketRunner from './components/PlanningSocketRunner.jsx';
import SideBar from './components/Sidebar/SideBar.jsx';

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan/',
);

export default function PlanningV2Root() {
  // eslint-disable-next-line @mint/no-use-location
  const { pathname: currentLocationPathName } = useLocation();
  const { pathname: planningRouterPathName } = routeApi.useMatch();

  const navigate = routeApi.useNavigate();

  const { mediaPlan } = routeApi.useSearch();

  const { data: mediaPlanMetadata } = useMediaPlanMetadataApi();

  useEffect(() => {
    if (!mediaPlanMetadata || mediaPlan === mediaPlanMetadata.mediaDataId) {
      return;
    }

    navigate({
      search: (search) =>
        chooseLevel(
          {
            level: MP_LEVELS.MEDIA_PLAN,
            mediaDataId: mediaPlanMetadata.mediaDataId,
          },
          search,
        ),
    });
  }, [mediaPlan, mediaPlanMetadata, navigate]);

  return (
    <RumComponentContextProvider componentArea="planning_v2">
      <ConditionalApprovalProcessProvider>
        <PlanningSocketRunner />
        <SlotPortal
          name="sidebar"
          priority={
            planningRouterPathName.includes(currentLocationPathName)
              ? SHOW_PLANNING_SIDEBAR
              : HIDE_PLANNING_SIDEBAR
          }
        >
          <SideBar />
        </SlotPortal>
        <Outlet />
        <ReactQueryDevtools initialIsOpen={false} />
      </ConditionalApprovalProcessProvider>
    </RumComponentContextProvider>
  );
}
